export const environment = {
  production: true,
  apiUrl: '',
  trustedToken: 'dev-trusted-token',
  enableDebug: false,
};
